export default "__VITE_ASSET__30b66d28__"